import { SelectField } from '../select-field';
import { FC } from 'react';
import map from 'lodash/map';
import { SelectFieldProps } from '../select-field/SelectField';
import { useTitle } from '../../../core/hooks/useTitle';
import { TitleDto } from '../../../core/http';

export const TitleField: FC<Omit<SelectFieldProps, 'items'>> = ({
  value,
  ...props
}) => {
  const { items } = useTitle();

  const selectItems = map(items, (item: TitleDto) => ({
    value: item.uuid,
    label: item.title
  }));

  return (
    <SelectField
      label="Title"
      value={value || ''}
      items={selectItems}
      {...props}
    />
  );
};
